<template>
    <div>
        <highcharts :constructorType="'stockChart'" class="hc" :options="chartOptions" ref="chart"></highcharts>
        <b-button-group size="sm" style="width: 100%;">
            <b-button class="series-selector" @click="showAll">Show All</b-button>
            <b-button class="series-selector" @click="hideAll">Hide All</b-button>
        </b-button-group>
    </div>
</template>

<script>
import Vue from "vue";
import Highcharts from "highcharts";
import Stock from "highcharts/modules/stock";
import HighchartsVue from "highcharts-vue";
import * as _ from "lodash";

Stock(Highcharts);
Vue.use(HighchartsVue);

// Tutorial that includes stockcharts
// https://www.highcharts.com/blog/tutorials/highcharts-vue-wrapper/ 
// https://github.com/highcharts/highcharts-vue#implementing-stockchart-mapchart-and-ganttchart 

export default {
    mixins: [],
    components: {
        // chart: Chart,
        // stockChart: StockChart,
    },
    props: {
        chartSeriesArray: Array,
    },
    data() {
        return {
            // look at this: https://stackoverflow.com/questions/70623999/highcharts-when-having-multiple-columns-for-the-same-x-axis-value-how-can-i-ge
            colorInputIsSupported: null,
            chartOptions: {
                credits: {
                    enabled: false
                },
                chart: {
                    type: 'column',
                    height: 500,
                    zoomType: 'xy'
                },
                title: {
                    text: 'Population Abundance'
                },
                tooltip: {
                    split: false,
                    shared: true,
                    outside: true,
                    backgroundColor: "rgba(240,240,240,.9)",
                    // useHTML: true,
                },
                legend: {
                    enabled: true,
                    maxHeight: 75,

                    // useHTML:true,
                    // labelFormatter: function () {
                    //     return this.name + ' (click to hide) <button onclick="buttonAction()">Button Action</button>';
                    // }
                },
                series: [],
                xAxis: [{
                    type: "datetime",
                    title: {
                        text: "Date",
                    },
                    labels: {
                        rotation: 30,
                        formatter: function() {
                            return Highcharts.dateFormat('%b/%e/%Y', this.value);
                        }
                        // format: '{value:%Y-%b-%e}'
                    }

                }],
                yAxis: [{ // Primary yAxis
                    gridLineColor: '#BBB',
                    labels: {
                        format: '{value}',
                        style: {
                            color: '#555' // Color of the Y-axis NUMERICAL labels
                        }
                    },
                    title: {
                        text: "Specimens Collected",
                        style: {
                            color: '#555', // Color of the Y-axis TEXT labels
                            textAlign: "right"
                        }
                    }
                }],
            }
        }
    },
    computed: {

    },
    created: function() {
        this.initchart();
    },
    mounted: function() {},
    methods: {
        initchart() {
            const that = this;
            _.forEach(Object.keys(that.chartSeriesArray), (taxon) => {
                that.chartOptions.series.push({
                    name: that.chartSeriesArray[taxon]['name'],
                    data: that.chartSeriesArray[taxon]['data'],
                    type: 'column',
                    visible: true,
                    // color: '#6fcd98'
                });
            });
        },
        showAll() {
            for(let i=0; i < this.chartOptions.series.length; i++) {
                this.$refs.chart.chart.series[i].show();
            }
        },
        hideAll() {
            for(let i=0; i < this.chartOptions.series.length; i++) {
                this.$refs.chart.chart.series[i].hide();
            }
        },
    }
};
</script>
<style>
.series-selector {
    background-color: #E6E5F5;
    width: 100%;
    height: 22px;
    padding: 0px;
    border: 0px;
    top: -20px;
    /* text */
    /* vertially align text */
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
    font-family: "Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif;
    font-size: 12px;
}
.series-selector:hover {
    background-color: #e6e6e6;
    color: black;
}
</style>
